<template>
    <div class="component-searchbar" style="width: auto;">
        <input type="text"
            class="form-control"
            placeholder="Buscar Hermano"
            v-model="text"
            id="component-search-brother">
        <div class="list" :hidden="hidden">
            <p class="message m-0">{{message}}</p>
            <div v-for="item in data" :key="item.id" class="item" @click="selected(item)">
                <div>
                    <span class="title">{{item.nombres}} {{item.apellido_paterno}}  {{item.apellido_materno}} </span>
                    <span class="d-block">
                        <span v-if="item.matricula">Matrícula <span class="matricula">{{item.matricula}}</span></span>
                    </span>
                </div>
            </div>
        </div>
        <br/>
        <div v-for="(selectedBrother, i ) in selectedBrothers" :key="i" class="alert alert-secondary alert-dismissible fade show" role="alert">
            <strong>{{selectedBrother.nombres}} {{selectedBrother.apellido_paterno}}  {{selectedBrother.apellido_materno}}</strong>
            <span class="d-block">
                <span v-if="selectedBrother.matricula">Matrícula <span class="matricula">{{selectedBrother.matricula}}</span></span>
            </span>
            <button type="button" class="close" @click="removeSelected(i)" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import selectpicker from 'bootstrap-select';

export default {
    props: [
        'id',
    ],
    data() {return {
        hidden: true,
        text: '',
        data: [],
        message: 'Al menos 4 letras...',
        brother: [],
        selectedBrothers: []
    }},
    mounted() {
        const vm = this;
        const searchbar = $('#component-search-brother');
        const clearBtn = $('#component-search-brother-clear');

        searchbar.focus(function() {
            vm.hidden = false;
        });
        searchbar.focusout(function() {
            setTimeout(function() {
                if(!searchbar.is(':focus')) {
                    vm.hidden = true;
                }
            }, 200);
        });

        let timeout = null;
        searchbar.on('input', function() {
            if(vm.text.length < 4) {
                vm.message = 'Al menos 4 letras...'
                vm.data = [];
            } else {
                vm.message = 'Buscando...';
            }

            if (timeout !== null) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function() {
                if(vm.text != '' && vm.text.length > 3) {
                    vm.getResults();
                }
            }, 1000);
        });

        clearBtn.on('click', function() {
            vm.text = '';
            vm.data = [];
            vm.message = 'Al menos 4 letras...'
            searchbar.focus();
        });
    },

    methods: {
        getResults() {
            axios.get('/panel/buscar/hermanos', {params: {text: this.text}}).then(res => {
                this.data = res.data;
                this.message = 'Se encontraron ' + res.data.length + ' resultados';
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 'Error en el componente v-header-searchbar');
                }
            });
        },

        selected(item) {
            const findedItem = this.selectedBrothers.filter( e => e.id === item.id )
            if (!findedItem.length){
                this.selectedBrothers.push(item);
            }
        },
        removeSelected(index) {
            if (this.selectedBrothers[index]){
                this.selectedBrothers.splice(index,1)
            }
        },
        vincularHermanos() {
            const ids = this.selectedBrothers.map( e => e.id)
            axios.post('/panel/vincular/hermano/' + this.id, {ids}).then(res => {
                toastr["success"]("Vinculados con exito");
                this.selectedBrothers = []
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 'Error en el componente v-header-searchbar');
                }
            });
        },
        vincularPersonas() {
            const ids = this.selectedBrothers.map( e => e.id)
            axios.post('/panel/user/vincular/persona/' + this.id, {ids}).then(res => {
                toastr["success"]("Vinculados con exito");
                this.selectedBrothers = []
            }).catch(e => {
                if(this.$store.state.debug) {
                    toastr["error"](e, 'Error en el componente v-header-searchbar');
                }
            });
        }

    },
}
</script>

<style scoped>


</style>
